export default __webpack_public_path__ + "static/media/signup_client_icon.8179746e.png";